export default require("./node_modules/redux-persist/lib/storage/index.js");